const css = `._9QiQ5W__pane{border-radius:var(--sizing-border-radius-large)}._9QiQ5W__default{background:var(--base-surfaces-secondary)}._9QiQ5W__success{background:var(--special-success-surfaces-secondary)}._9QiQ5W__warning{background:var(--special-warning-surfaces-secondary)}._9QiQ5W__danger{background:var(--special-destructive-surfaces-secondary)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"danger":"_9QiQ5W__danger","success":"_9QiQ5W__success","pane":"_9QiQ5W__pane","default":"_9QiQ5W__default","warning":"_9QiQ5W__warning"};
